
const customAuthUrl = (baseUrl, queryParams = []) => {
  const authUrl = new URL(baseUrl || process.env.REACT_APP_AUTH_URL);
  const authSearchParams = new URLSearchParams(authUrl.search);
  queryParams.forEach(([key, value]) => {
    authSearchParams.append(key, value);
  });
  authUrl.search = authSearchParams.toString();
  return authUrl.toString();
};

export const loginUrl = customAuthUrl(null, [['redirect_uri', window.location]]);
export const logoutUrl = customAuthUrl(`${process.env.REACT_APP_AUTH_URL}/logout`, [['redirect_uri', window.location]]);
export { customAuthUrl };
